module.exports = __webpack_public_path__ + "img/left_alignac.6a8523a7.svg";